<template>
	<div>
		<ul class="article-list" :class="['article-list-' + mode_]">
			<li class="clearfix" v-for="(item, index) in listData" :key="item.id" @click="goDetail(item.contentId)">
				<img class="article-img" v-if="item.listPic || item.attrs && item.attrs.listPic" :src="(item.listPic || item.attrs && item.attrs.listPic) | imgUrl" />
				<div class="article-right-content">
					<div class="article-title">{{item.title}}</div>
					<div class="article-time" v-if="mode_ === 1 || mode_ === 2 || mode_ === 4">
						<div class="fr" v-if="mode_ === 1">
							<div class="article-icon">
								<img src="../../assets/img/culturalActivity/lt.png" />
								<span>{{item.comments}}</span>
							</div>
							<div class="article-icon">
								<img src="../../assets/img/culturalActivity/zan.png" />
								<span>{{item.ups}}</span>
							</div>
						</div>
						<div class="fr delete-text" v-else-if="mode_ === 2" @click.stop="cancleCollect(item.contentId, index)">取消收藏</div>
						<span>{{item.releaseTimestamp | time}}</span>
						<template v-if="item.contentTags && item.contentTags.length">|</template>
						<span v-for="it in item.contentTags" :key="it.id">{{it.tagName}}</span>
					</div>
					<div class="article-time" v-else-if="mode_ === 3">
						<span>活动时间：{{item.attrs && item.attrs.startDate}}</span>
					</div>
					<div class="article-desc" v-else-if="mode_ === 9">{{item.contentExt && item.contentExt.description}}</div>
				</div>
			</li>
		</ul>
		<ss-no-data v-if="!finish && busy" text="数据加载中" />
		<ss-no-data v-else-if="finish && busy && listData.length === 0" mode="image" text="暂无相关的信息" />
	</div>
</template>

<script>
	export default {
		data() {
			return {
				listData: []
			}
		},
		watch: {
			value: {
				handler(val) {
					this.listData = val.concat();
				},
				deep: true,
				immediate: true
			},
		},
		props:{
			value: {
				type: Array,
				default: () => {
					return []
				}
			},
			/**
			 * 4 搜索结果
			 */
			mode: {
				type: [String, Number],
				default: 1
			},
			detailPath: {
				type: String,
				default: '/cultureAround/info/'
			},
			finish: {
				type: Boolean,
				default: false
			},
			busy: {
				type: Boolean,
				default: false
			}
		},
		computed: {
			mode_() {
				return this.mode ? parseInt(this.mode) : 1;
			}
		},
		methods: {
			async cancleCollect(id, index) {
				let res = await this.collection(id, true);
				if(res){
					this.listData.splice(index, 1);
				}
			},
			async collection(contentId, isCollect) {
				let res = await this.$http(isCollect ? 'collectionCancel' : 'collection', {
					contentId: contentId
				})
				return res.code ===1 ? true : false;
			},
			goDetail(id) {
				if(this.mode_ === 4 || this.mode_ === 2) return this.$searchJump(id, this)
				if(!this.detailPath) alert('跳转地址错误');
				this.$router.push({
					path: this.detailPath + id
				})
			}
		}
	}
</script>

<style lang="scss" scoped="scoped">
	.article-list{
		padding: 10px 134px 38px 127px;
		&.article-list-9{
			padding: 32px 34px;
			li{
				border: 1px solid #D4D4D4;
				padding: 0;
				& + li {
					margin-top: 28px;
				}
				.article-img{
					width: 298px;
          & + .article-right-content{
            width: 622px;
          }
				}
				.article-right-content{
					padding-top: 20px;
					width: 820px;
					height: 198px;
				}
			}
		}
		li{
			padding: 10px 0 10px 10px;
			border-bottom: 1px dotted #DEDEDE;
			position: relative;
			cursor: pointer;
			&:hover{
				.article-title{
					color: #0260FC;
				}
			}
			.article-title{
				font-size: 20px;
				font-weight: 400;
				color: #202A30;
				line-height: 24px;
			}
			.article-desc{
				margin-top: 20px;
				font-size: 14px;
				font-weight: 400;
				color: #666666;
				line-height: 18px;
			}
			.article-time{
				@include abs(null, 20px, 0, 10px);
				font-size: 14px;
				font-weight: 400;
				color: #B9B9B9;
				line-height: 18px;
				margin-top: 15px;
				span{
					margin: 0 10px;
				}
				.delete-text{
					font-size: 14px;
					font-weight: 400;
					color: #1A6FFE;
					line-height: 18px;
				}
			}
			.article-icon{
				display: inline-block;
				color: #666666;
				img{
					width: 16px;
					height: 15px;
					display: inline-block;
					vertical-align: middle;
					margin-right: 8px;
				}
				span{
					display: inline-block;
					min-width: 72px;
				}
			}
			.article-img{
				width: 154px;
				display: block;
				float: left;
			}
			.article-right-content{
				position: relative;
				float: left;
				width: 760px;
				padding: 0 20px;
				height: 100px;
			}
		}
	}
</style>
